export default __webpack_public_path__ + "static/media/img_baseBunnyRattle_rose.2cdefe96.jpg";